var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Container, CssBaseline, Divider, Grid, makeStyles, ThemeProvider, Typography } from '@material-ui/core';
import { CompanyName } from '../../organisms/CompanyName';
var useStyles = makeStyles(function (theme) { return ({
    section: {
        padding: theme.spacing(1),
    },
    image: {
        width: '100%',
        height: '100%',
    },
}); });
var UnavailableTemplate = function (props) {
    var classes = useStyles();
    return (React.createElement(Container, { disableGutters: true },
        React.createElement(CssBaseline, null),
        React.createElement(Grid, { container: true, direction: "row", justifyContent: "center", alignItems: "center" },
            React.createElement(Grid, { item: true, xs: 12, className: classes.section }, props.companyImageUrl ? (React.createElement("img", { src: props.companyImageUrl, className: classes.image, alt: props.organizationName.companyName })) : (React.createElement(CompanyName, __assign({}, props.organizationName)))),
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(Typography, { align: 'center', variant: 'body1' }, "\u3053\u306E\u30AF\u30FC\u30DD\u30F3\u306F\u5229\u7528\u3067\u304D\u307E\u305B\u3093\u3002"))),
        React.createElement(Divider, { variant: "fullWidth" })));
};
export var UnavailableTemplateWithTheme = function (props) {
    var theme = props.theme, data = __rest(props, ["theme"]);
    return (React.createElement(ThemeProvider, { theme: theme },
        React.createElement(UnavailableTemplate, __assign({}, data))));
};
//# sourceMappingURL=UnavailableTemplate.js.map